Vue.component('ack-alpha-ai-plan', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-alpha-ai-plan',
	mounted() {},
	props: {
		planItems: {
			// :product-info
			type: Array,
			required: true,
		},
		isMobile: {
			type: Boolean,
			required: true,
		},
	},
	computed: {
		...Vuex.mapGetters('shop', ['isStoreAvailable']),
	},
	data() {
		return {
			activeTab: 'two-years', // 'monthly' 'yearly' 'two-years'
		};
	},
	methods: {
		//...Vuex.mapActions(['sayHi', 'someAction']),
		...Vuex.mapActions('shop', ['addToCartFromProperties', 'buyNow']),

		onGetStartedPaidVersionsClick() {
			switch (this.activeTab) {
				case 'monthly':
					this.onGetStartedMonthlyClick();
					break;
				case 'yearly':
					this.onGetStartedOneYearClick();
					break;
				case 'two-years':
					this.onGetStartedTwoYearClick();
					break;
			}
		},

		onGetStartedMonthlyClick() {
			if (this.isStoreAvailable) {
				this.addToCartFromProperties({
					productId: 'gid://shopify/Product/6777579962471',
					variantId: 'gid://shopify/ProductVariant/40179161137255',
					sellingPlanId: 'gid://shopify/SellingPlan/7707689063',
				});
			} else {
				this.buyNow({
					variantId: 'gid://shopify/ProductVariant/40179161137255',
					sellingPlanId: 'gid://shopify/SellingPlan/7707689063',
				}).then((url) => {
					openCheckoutUrl(url);
				});
			}
		},
		onGetStartedOneYearClick() {
			if (this.isStoreAvailable) {
				this.addToCartFromProperties({
					productId: 'gid://shopify/Product/6777577046119',
					variantId: 'gid://shopify/ProductVariant/41256766079079',
					sellingPlanId: 'gid://shopify/SellingPlan/7588380775',
				});
			} else {
				this.buyNow({
					variantId: 'gid://shopify/ProductVariant/41256766079079',
					sellingPlanId: 'gid://shopify/SellingPlan/7588380775',
				}).then((url) => {
					openCheckoutUrl(url);
				});
			}
		},
		onGetStartedTwoYearClick() {
			if (this.isStoreAvailable) {
				this.addToCartFromProperties({
					productId: 'gid://shopify/Product/6777577046119',
					variantId: 'gid://shopify/ProductVariant/41256766079079',
					sellingPlanId: 'gid://shopify/SellingPlan/9120579687',
				});
			} else {
				this.buyNow({
					variantId: 'gid://shopify/ProductVariant/41256766079079',
					sellingPlanId: 'gid://shopify/SellingPlan/9120579687',
				}).then((url) => {
					openCheckoutUrl(url);
				});
			}
		},
	},
	beforeDestroy() {},
	watch: {
		handler() {},
		deep: false,
	},
});
